var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var ChevronDownSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12.8520796,7.85246487 L8.99980356,11.7117969 L5.14589789,7.84948537 C4.95280965,7.65580007 4.9530516,7.3423325 5.1464386,7.1489455 C5.33974819,6.95563591 5.65315648,6.95560844 5.84649995,7.14888413 L9.00019644,10.2979762 L12.1534623,7.14712069 C12.3464198,6.95432486 12.6591347,6.95445595 12.8519305,7.14741348 L12.8534546,7.1489455 C13.0465659,7.34391755 13.0459516,7.65824916 12.8520796,7.85246487 Z" })));
};
ChevronDownSmall.displayName = 'ChevronDownSmall';
export default ChevronDownSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronDownSmall.js.map